/* eslint-disable no-nested-ternary */
/* eslint-disable no-underscore-dangle */
/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/ban-ts-comment */

import React, { ReactNode, useState, useEffect, useCallback } from 'react';
import { Button, Col, DatePicker, Input, Row, Select, Popover } from 'antd';

import { SearchOutlined } from '@ant-design/icons';
import { formatDate, formatDateTime } from 'shared/utils/dateTime';
import { Text, TableSearch, Tag } from 'shared/components';
import formatCurrency from 'shared/utils/formatCurrency';
import { HaierCostingProvider } from 'views/Costing/common/context/HaierCostingContext';
import moment from 'moment';
import { Link, Route, useHistory, useRouteMatch } from 'react-router-dom';
import { HaierCostingStatus } from 'views/Costing/common/model/haierCostingStatus.model';
import { axiosErp } from 'shared/config/axios';
import { getStoredAuthToken } from 'shared/utils/authToken';

import { Container, StyledModal, ToolsContainer } from './Styles';
import ModalHaierCostingDetail from './ModalHaierCostingDetail';
import HaierCostingTabs from './HaierCostingTabs';

const { Option } = Select;
const { RangePicker } = DatePicker;

const HaierCostingListWrapper: React.FC = () => {
  return (
    <HaierCostingProvider>
      <HaierCostingList />
    </HaierCostingProvider>
  );
};

const HaierCostingList: React.FC = () => {
  const match = useRouteMatch();
  const history = useHistory();
  const token = getStoredAuthToken();

  const [isLoading, setLoading] = useState(false);
  const [data, setDataCosting] = useState<any>(null);

  const [tab, setTab] = useState<HaierCostingStatus>(HaierCostingStatus.WAITING_CONFIRM);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasEdit, setHasEdit] = useState('all');
  const [vendorName, setVendorName] = useState('');
  const [tripNo, setTripNo] = useState('');
  const [jobNumber, setJobNumber] = useState('');
  const [employeeName, setEmployeeName] = useState('');
  const [customerName, setCustomerName] = useState('');
  const [costingDate, setCostingDate] = useState('');
  const [costingNumber, setCostingNumber] = useState('');
  const [orderBy, setOrderBy] = useState('');
  const [orderType, setOrderType] = useState('');

  const functionGetData = useCallback(async () => {
    setLoading(true);
    try {
      const costingData = await axiosErp(token).post(`/costing-job-table`, {
        params: {
          jobNumber,
          costingNumber,
          employeeName,
          customerName,
          vendorName,
          tripNo,
          costingStatus: tab || 1,
          costingDate,
          editStatus: hasEdit === 'all' ? null : hasEdit,
        },
        sort: {
          order_by: orderBy || 'costingDate',
          order_type: orderType || -1,
        },
        page: currentPage,
        showData: pageSize,
      });
      setDataCosting(costingData.data);
    } catch (error) {
      console.error('ERROR TO LOAD COSTING TABLE LIST: ', error);
    } finally {
      setLoading(false);
    }
  }, [
    token,
    jobNumber,
    costingNumber,
    employeeName,
    customerName,
    vendorName,
    tripNo,
    tab,
    costingDate,
    orderBy,
    orderType,
    currentPage,
    pageSize,
  ]);

  const columns = [
    {
      title: 'เครื่องมือ',
      dataIndex: 'tools',
      width: 80,
    },
    {
      title: 'มีแก้ไข',
      dataIndex: 'editStatus',
      width: 80,
      search: (
        <Select
          defaultValue="all"
          style={{ width: '100%' }}
          value={hasEdit}
          onChange={(value) => setHasEdit(value)}
          placeholder="เลือก"
        >
          <Option value="all">ทั้งหมด</Option>
          <Option value="2">มี</Option>
          <Option value="1">ไม่มี</Option>
        </Select>
      ),
    },
    {
      title: 'วันที่ส่งรายการ',
      dataIndex: 'costingDate',
      sortName: 'costingDate',
      width: 200,
      search: (
        <RangePicker
          onChange={(values) => {
            setCostingDate(
              values === null
                ? ''
                : `${values?.[0]?.format('YYYY-MM-DD')}:${values?.[1]?.format('YYYY-MM-DD')}`,
            );
          }}
          format="YYYY/MM/DD"
          placeholder={['เริ่มต้น', 'สิ้นสุด']}
          ranges={{
            วันนี้: [moment(), moment()],
            สัปดาห์นี้: [moment().startOf('week'), moment().endOf('week')],
            เดือนนี้: [moment().startOf('month'), moment().endOf('month')],
            ปีนี้: [moment().startOf('year'), moment().endOf('year')],
          }}
        />
      ),
    },
    {
      title: 'รหัสต้นทุน/ขาย',
      dataIndex: 'costingNumber',
      sortName: 'costingNumber',
      width: 130,
      search: (
        <Input
          allowClear
          value={costingNumber}
          placeholder="ค้นหา"
          onChange={(event) => setCostingNumber(event.target.value)}
        />
      ),
    },
    {
      title: 'รหัสทริป',
      dataIndex: 'tripNo',
      sortName: 'tripNo',
      width: 130,
      search: (
        <Input
          allowClear
          value={tripNo}
          placeholder="ค้นหา"
          onChange={(event) => setTripNo(event.target.value)}
        />
      ),
    },
    {
      title: 'รหัสขนส่ง',
      dataIndex: 'jobNumber',
      sortName: 'jobNumber',
      width: 160,
      search: (
        <Input
          allowClear
          value={jobNumber}
          placeholder="ค้นหา"
          onChange={(event) => setJobNumber(event.target.value)}
        />
      ),
    },
    {
      title: 'ลูกค้า',
      dataIndex: 'customerName',
      search: (
        <Input
          allowClear
          value={customerName}
          placeholder="ค้นหา"
          onChange={(event) => setCustomerName(event.target.value)}
        />
      ),
    },
    {
      title: 'ต้นทุนก่อนภาษี',
      dataIndex: 'cost',
      sortName: 'cost',
      width: 140,
      align: 'right',
      style: {
        padding: '6px',
        alignItems: 'flex-end',
        backgroundColor: '#FFEEB6',
        height: '70px',
        margin: '-6px',
      },
    },
    {
      title: 'รายได้ก่อนภาษี',
      dataIndex: 'revenue',
      sortName: 'revenue',
      width: 140,
      align: 'right',
      style: {
        padding: '6px',
        alignItems: 'flex-end',
        backgroundColor: '#BFDAF8',
        height: '70px',
        margin: '-6px',
      },
    },
    {
      title: 'กำไร-ขาดทุน',
      dataIndex: 'profit',
      sortName: 'profit',
      width: 140,
      align: 'right',
      style: {
        padding: '6px',
        alignItems: 'flex-end',
        backgroundColor: '#B9DEAF',
        height: '70px',
        margin: '-6px',
      },
    },
    {
      title: 'อัตรากำไร',
      dataIndex: 'profitRate',
      sortName: 'profitRate',
      width: 140,
      align: 'right',
    },
    {
      title: 'อัตรากำไรสุทธิ',
      dataIndex: 'netProfitRate',
      sortName: 'netProfitRate',
      width: 140,
      align: 'right',
    },
    {
      title: 'ผู้รับเงิน',
      dataIndex: 'vendorName',
      width: 300,
      search: (
        <Input
          allowClear
          value={vendorName}
          placeholder="ค้นหา"
          onChange={(event) => setVendorName(event.target.value)}
        />
      ),
    },
    {
      title: 'ผู้ส่งราคา',
      dataIndex: 'employeeName',
      width: 150,
      search: (
        <Input
          allowClear
          value={employeeName}
          placeholder="ค้นหา"
          onChange={(event) => setEmployeeName(event.target.value)}
        />
      ),
    },
    {
      title: 'ใบสั่งจ่าย',
      dataIndex: 'paymentNumber',
      width: 100,
    },
    {
      title: 'ใบแจ้งหนี้',
      dataIndex: 'invoiceNumber',
      width: 100,
    },
    {
      title: 'อัพเดทล่าสุด',
      dataIndex: 'lastUpdate',
      sortName: 'lastUpdate',
      width: 150,
    },
  ];

  let tableData: Array<{
    key: number;
    tools: ReactNode;
    jobNumber: ReactNode;
    cost: ReactNode;
    revenue: ReactNode;
    profit: ReactNode;
    profitRate: ReactNode;
    netProfitRate: ReactNode;
    employeeName: ReactNode;
    customerName: ReactNode;
    vendorName: ReactNode;
    editStatus: ReactNode;
    tripNo: string;
    costingNumber: string;
    costingStatus: ReactNode;
    costingDate: string;
    paymentNumber: ReactNode;
    invoiceNumber: ReactNode;
    lastUpdate: string;
  }> = [];

  let totalDocument = 0;
  if (data && data.costings.length > 0) {
    tableData = data.costings.map((item, index) => ({
      key: index,
      tools: (
        <ToolsContainer>
          <Link to={`${match.path}/detail/${item._id}`}>
            <Button
              // @ts-expect-error
              type="grey--text-only"
              icon={<SearchOutlined />}
              size="small"
              style={{ marginRight: 10 }}
            />
          </Link>
        </ToolsContainer>
      ),
      costingDate: formatDate(item.costingDate),
      lastUpdate: formatDate(item.lastUpdate),
      costingNumber: item.costingNumber,
      customerName: item.customer ? item.customer.customerName : '-',
      vendorName: item.vendor ? item.vendor.vendorName : '-',
      employeeName: item.employee ? item.employee.employeeName : '-',
      tripNo: item.tripNo,
      editStatus: (
        <Tag outline circle customColor={item.editStatus === 1 ? 'grey' : 'blue'}>
          {item.editStatus === 1 ? 'No' : 'Yes'}
        </Tag>
      ),
      jobNumber: item.jobNumber,
      cost: (
        <div
          style={{
            backgroundColor: '#FFF8E1',
            margin: '-6px',
            padding: '6px',
          }}
        >
          <Text strong customType={item.cost < 0 ? 'danger' : 'primary'}>
            {formatCurrency(item.cost || 0)}
          </Text>
        </div>
      ),
      revenue: (
        <div
          style={{
            backgroundColor: '#ECF5FF',
            margin: '-6px',
            padding: '6px',
          }}
        >
          <Text strong customType={item.revenue < 0 ? 'danger' : 'primary'}>
            {formatCurrency(item.revenue || 0)}
          </Text>
        </div>
      ),
      profit: (
        <div
          style={{
            backgroundColor: `${item.profit < 0 ? '#FADBDA' : '#EDF9E9'}`,
            margin: '-6px',
            padding: '6px',
          }}
        >
          <Text strong customType={item.profit < 0 ? 'danger' : 'success'}>
            {formatCurrency(item.profit || 0)}
          </Text>
        </div>
      ),
      profitRate: (
        <Text strong customType={item.profitRate < 0 ? 'danger' : 'primary'}>
          {item.profitRate || 0}%
        </Text>
      ),
      netProfitRate: (
        <Text strong customType={item.netProfitRate < 0 ? 'danger' : 'primary'}>
          {item.netProfitRate || 0}%
        </Text>
      ),
      paymentNumber:
        item.payment.length > 0 ? (
          <Popover
            placement="rightTop"
            content={
              <div>
                <Text strong>รายการใบสั่งจ่ายที่อ้างอิง</Text>
                <br />
                {item.payment.map((paymentItem: any, index: number) => (
                  <Text key={paymentItem}>
                    {index + 1}: {paymentItem} <br />
                  </Text>
                ))}
              </div>
            }
          >
            <Tag outline circle customColor="grey">
              <Text>{item.payment.length} รายการ</Text>
            </Tag>
          </Popover>
        ) : (
          '-'
        ),
      invoiceNumber:
        item.invoice.length > 0 ? (
          <Popover
            placement="rightTop"
            content={
              <div>
                <Text strong>รายการใบแจ้งหนี้ที่อ้างอิง</Text>
                <br />
                {item.invoice.map((invoiceItem: any, index: number) => (
                  <Text key={invoiceItem}>
                    {index + 1}: {invoiceItem} <br />
                  </Text>
                ))}
              </div>
            }
          >
            <Tag outline circle customColor="grey">
              <Text>{item.invoice.length} รายการ</Text>
            </Tag>
          </Popover>
        ) : (
          '-'
        ),
      updatedAt: formatDateTime(item.updatedAt),
    }));

    totalDocument = data.totalDocument || 0;
  }

  useEffect(() => {
    functionGetData();
  }, [
    tab,
    costingDate,
    currentPage,
    pageSize,
    costingNumber,
    jobNumber,
    orderBy,
    orderType,
    vendorName,
    employeeName,
    customerName,
    tripNo,
    hasEdit,
    functionGetData,
  ]);

  return (
    <Container>
      <Row align="middle" style={{ borderBottom: '1px solid #e3e3e3' }}>
        <Col span={16}>
          <HaierCostingTabs
            tab={tab}
            name="costing"
            onChange={(value) => {
              setTab(value);
              setCurrentPage(1);
            }}
          />
        </Col>
      </Row>

      <Row
        align="middle"
        justify="space-between"
        style={{ borderBottom: '1px solid #e3e3e3', height: 60 }}
      >
        <Col>
          <Select defaultValue="all" style={{ width: 180 }}>
            <Option value="all">รายการทั้งหมด ({totalDocument})</Option>
          </Select>
        </Col>
        <Col>
          แสดง{' '}
          <Select
            onChange={(value) => {
              setCurrentPage(1);
              setPageSize(value);
            }}
            defaultValue={pageSize}
            style={{ width: 80 }}
          >
            <Option value={10}>10</Option>
            <Option value={20}>20</Option>
            <Option value={30}>30</Option>
          </Select>
        </Col>
      </Row>

      <TableSearch
        columns={columns}
        dataSource={tableData}
        loading={isLoading}
        pagination={{
          current: currentPage,
          pageSize,
          total: totalDocument,
          showSizeChanger: false,
          onChange: (value) => setCurrentPage(value),
        }}
        onSort={(sort) => {
          setOrderBy(sort.orderBy);
          setOrderType(sort.orderType);
        }}
      />

      <Route
        // @ts-expect-error
        except
        path={`${match.path}/detail/:costingId`}
        render={(routeProps) => (
          <StyledModal
            visible
            onCancel={() => {
              history.push(match.url);
            }}
            width="100%"
            closable={false}
            className="custom-modal"
            footer={null}
            destroyOnClose
          >
            <ModalHaierCostingDetail
              costingId={routeProps.match.params.costingId}
              backUrl={match.url}
            />
          </StyledModal>
        )}
      />
    </Container>
  );
};

export default HaierCostingListWrapper;
